export enum STATUS {
    LOADING = "LOADING",
    INITIAL_LOADING = "INITIAL_LOADING",
    ERROR = "ERROR",
    READY = "READY",
    VIRGIN = "VIRGIN",
}
